export default "__VITE_ASSET__79xrRZU$__"